/**
 * @generated SignedSource<<7fae7c543c7e0bfc0423ce5cdfc40837>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FilterRefinement$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AssigneePicker">;
  readonly " $fragmentType": "FilterRefinement";
};
export type FilterRefinement$key = {
  readonly " $data"?: FilterRefinement$data;
  readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scope"
    }
  ],
  "kind": "Fragment",
  "name": "FilterRefinement",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "scope"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AssigneePicker"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "58f71f798e1ba4f3dbff1f98bd2e5b5b";

export default node;
